module.exports = __webpack_public_path__ + "static/media/23.44787e27.png";